import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useSelector } from "react-redux";
import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import 'react-overlay-loader/styles.css';

// PaymentSubHeader
const PaymentSubHeader = (props) => {

  let account_type = useSelector(state => {
    if (state.user && state.user.user_info && state.user && state.user.user_info.profile && state.user.user_info.profile.account_type) {
      return state.user.user_info.profile.account_type
    } else {
      return 'default'
    }
  });
  let subscription_status = useSelector(state => {
    if (state.user && state.user.subscription_status) {
      return state.user.subscription_status
    } else {
      return 'unknown'
    }
  });

  let navigate = useNavigate();
  let [pathname, setPathname] = useState('');

  useEffect(() => {
    setPathname(window.location.pathname)
  }, [window.location.pathname]);

  let selectedColor = '#000000'

  return (
    <div style={{
      paddingTop: 20,
      paddingBottom: 20,
    }}>
      <Container>

        <Row style={{
          fontSize: 15,
        }}>

          <Col md="12" xs="12" style={{
            textAlign: 'right',
          }}>

            <Link to="/payment_top" style={{
              marginRight: 10,
              textDecoration: 'none',
              color: pathname === '/payment_top' ? selectedColor : '#777777',
              fontWeight: 'bold',
            }}>お支払いトップ</Link>

            {account_type !== "invoice_client" && (
              <Link to="/payment_add" style={{
                marginRight: 10,
                textDecoration: 'none',
                color: pathname === '/payment_add' ? selectedColor : '#777777',
                fontWeight: 'bold',
              }}>サブスクリプションの追加 </Link>
            )}

            <Link to="/payment_history" style={{
              marginRight: 10,
              textDecoration: 'none',
              color: pathname === '/payment_history' ? selectedColor : '#777777',
              fontWeight: 'bold',
            }}>お支払い履歴</Link>

          </Col>
        </Row>

      </Container>
    </div>
  )
}

export default PaymentSubHeader

// {subscription_status === "incomplete" && (
//   <Link to="/payment_add" style={{
//     marginRight: 10,
//     textDecoration: 'none',
//     color: pathname === '/payment_add' ? selectedColor : '#777777',
//     fontWeight: 'bold',
//   }}>お支払い方法の追加 {subscription_status} </Link>
// )}
